var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clearfix fs13 p20 detail-row-last" },
    [
      _c(
        "job-preview-right-column",
        _vm._g(
          {
            attrs: {
              "text-count-mode": _vm.textCountMode,
              "highlight-mode": _vm.highlightMode,
              "comment-class": "topic",
              "comment-highlights": _vm.commentHighlights,
              "text-count-class": "topic",
              "text-counts": _vm.textCounts,
            },
          },
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fll row-left" }, [
        _vm.freeTopic.title
          ? _c("p", {
              staticClass: "fwB",
              attrs: {
                id:
                  _vm.targetIdMap.freeTopics.title + "-" + _vm.freeTopic.index,
                "data-test": "title",
              },
              domProps: { textContent: _vm._s(_vm.freeTopic.title) },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("p", {
          staticClass: "pega-pre-wrap",
          attrs: {
            id: _vm.targetIdMap.freeTopics.body + "-" + _vm.freeTopic.index,
            "data-test": "body",
          },
          domProps: { textContent: _vm._s(_vm.freeTopic.body) },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flr" }, [
        _vm.freeTopic.photo
          ? _c("img", {
              staticClass: "offer-img-sub",
              attrs: {
                id:
                  _vm.targetIdMap.freeTopics.photo + "-" + _vm.freeTopic.index,
                src: _vm.getPhotoUrl(_vm.freeTopic.photo),
                "data-test": "photo",
              },
              on: {
                load: function ($event) {
                  return _vm.$emit("onLoadImage")
                },
                error: function ($event) {
                  return _vm.$emit("onLoadImage")
                },
              },
            })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }